module.exports = __webpack_public_path__ + "img/default_live_bg.24235011.png";